(function organizationalUnitFindControllerDefinition() {
    'use strict';

    angular.module('OrganizationalUnit')
        .controller('OrganizationalUnitFindController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'adminOrganizationalUnitService', 'authExtend', 'organizartionalUnitAction',
            function organizationalUnitFindController($scope, config, $state, $translate, errors, adminOrganizationalUnitService, authExtend, organizartionalUnitAction) {
                $scope.find =
                    {
                        Name: '',
                        showNoData: false
                    };

                $scope.organizationalUnits = [];
                $scope.hideAddBtn = !authExtend.isInRole('ORGANIZATIONALUNIT CREATE');
                $scope.hideEditBtn = !authExtend.isInRole('ORGANIZATIONALUNIT WRITE');
                $scope.enableDisableBtn = authExtend.isInRole('ORGANIZATIONALUNIT ENABLED DISABLED');
                $scope.hideAssociateProfile = !authExtend.isInRole('ORGANIZATIONALUNIT WRITE');
                $scope.hasDigitalFileAccess = authExtend.isInRole('ASOCIATETCDIGITALFILE');

                $scope.find = function () {

                    $scope.find.showNoData = false;
                    return adminOrganizationalUnitService.get(
                        $scope.find.Name,
                        undefined,
                        undefined,
                        $scope.data.currentPage,
                        $scope.data.itemsPerPage
                    ).then(function getOk(result) {
                        $scope.organizationalUnits = result.value;
                        $scope.data.totalItems = result.totalCount;
                        $scope.data.from = 1 + ($scope.data.itemsPerPage * ($scope.data.currentPage - 1));
                        if ($scope.organizationalUnits.length === 0)
                            $scope.find.showNoData = true;
                    }, function getError(error) {
                        errors.showError(error);
                    });
                };

                $scope.modify = function (organizationalUnit) {
                    $state.go('organizational-unit-modify', { id: organizationalUnit.id });
                };

                $scope.add = function () {
                    $state.go('organizational-unit-add');
                };

                $scope.view = function (organizationalUnit) {
                    $state.go('organizational-unit-detail', { id: organizationalUnit.id });
                };

                $scope.enable = function (ou, index) {
                    return organizartionalUnitAction.enable(ou).then(function getOk() {
                        $scope.find();
                    });
                };

                $scope.disable = function (ou, index) {
                    return organizartionalUnitAction.disable(ou).then(function getOk() {
                        $scope.find();
                    });
                };

                $scope.associateContainerType = function (organizationalUnit) {
                    $state.go('organizational-unit-associate-profile', { id: organizationalUnit.id });
                };

                $scope.associateContainerTypeLD = function (organizationalUnit) {
                    $state.go('organizational-unit-associate-container-type', { id: organizationalUnit.id });
                };
                $scope.load = function () {
                    $scope.data = {
                        currentPage: 1,
                        totalItems: 0,
                        itemsPerPage: 15,
                        from: 0
                    };

                    $translate(['PaginationNext', 'PaginationPrev', 'PaginationLastFem', 'PaginationFirstFem'])
                        .then(function (translated) {
                            $scope.paginatorTranslations = {
                                nextText: translated.PaginationNext,
                                previousText: translated.PaginationPrev,
                                lastText: translated.PaginationLastFem,
                                firstText: translated.PaginationFirstFem
                            };
                        });
                    $scope.find();
                }

                $scope.load();
            }
        ]);
})();